import { Fragment, useEffect, useState, useRef, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { gsap, ScrollTrigger } from "gsap/all";
import "./Footer.scss";

function Footer() {
  gsap.registerPlugin(ScrollTrigger);
  const headingRef = useRef();

  const location = useLocation();

  const [emails, setEmails] = useState({});
  const getEmails = () => {
    fetch("https://iosindia.com/api/footer-emails/")
      .then((res) => res.json())
      .then((data) => {
        const emailsMap = {};
        for (const item of data) {
          if (!emailsMap.hasOwnProperty(item.department)) {
            emailsMap[item.department] = [];
          }
          emailsMap[item.department].push(item);
        }
        setEmails(emailsMap);
      });
  };

  const headingQ = gsap.utils.selector(headingRef);

  useEffect(() => {
    getEmails();
    gsap
      .timeline({
        scrollTrigger: {
          trigger: headingQ("span"),
          scrub: true,
        },
      })
      .from(headingQ("span"), {
        x: 50,
      })
      .from(
        headingQ(".bg"),
        {
          x: 150,
        },
        0
      );
  }, []);

  useLayoutEffect(() => {
    ScrollTrigger.update();
  }, [location]);

  return (
    <Fragment>
      <footer>
        <div className="container mx-auto px-5 md:px-20 pt-10 md:pt-20">
          <h1 ref={headingRef} className="heading">
            <span className="block">LET'S CONNECT</span>
            <div className="bg black-bg">LET'S CONNECT</div>
          </h1>
          <p className="text-sm mt-10 mb-2">SEND US AN EMAIL</p>
          <p>
            <a
              className="text-2xl uppercase mt-5"
              href="mailto:info@iosindia.com"
            >
              info@iosindia.com
            </a>
          </p>
          <div className="mt-5 grid md:grid-cols-4 gap-10">
            <div className="col">
              <h3>For Talent</h3>
              {emails[1]?.map((item, i) => (
                <Fragment>
                  <p className="md:max-w-sm uppercase">{item.name}</p>
                  <a className="block mb-5" href={"mailto:" + item.email}>
                    {item.email}
                  </a>
                </Fragment>
              ))}
            </div>
            <div className="col">
              <h3>FOR SALES AND MARKETING</h3>
              {emails[2]?.map((item, i) => (
                <Fragment>
                  <p className="md:max-w-sm uppercase">{item.name}</p>
                  <a className="block mb-5" href={"mailto:" + item.email}>
                    {item.email}
                  </a>
                </Fragment>
              ))}
            </div>
            <div className="col">
              <h3>For Operations</h3>
              {emails[3]?.map((item, i) => (
                <Fragment>
                  <p className="md:max-w-sm uppercase">{item.name}</p>
                  <a className="block mb-5" href={"mailto:" + item.email}>
                    {item.email}
                  </a>
                </Fragment>
              ))}
            </div>
            <div className="col">
              <h3>For Pr & Media</h3>
              {emails[4]?.map((item, i) => (
                <Fragment>
                  <p className="md:max-w-sm uppercase">{item.name}</p>
                  <a className="block mb-5" href={"mailto:" + item.email}>
                    {item.email}
                  </a>
                </Fragment>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <p className="text-sm mt-10">OUR OFFICES</p>
            <div className="mt-5 grid md:grid-cols-3 gap-10">
              <div className="col">
                <h3>HEAD OFFICE:</h3>
                <p className="md:max-w-sm">
                  243A, first Floor, DLF Avenue, Saket District Centre, New
                  Delhi - 110017
                </p>
                <p className="md:max-w-sm">Phone- 011 4654 4289</p>
              </div>
              <div className="col">
                <h3>Delhi:</h3>
                <p className="md:max-w-sm">
                  406, 4th Floor, DLF Courtyard, District Center, Saket, New
                  Delhi-110017
                </p>
                <p className="md:max-w-sm">Phone- 011 46544228</p>
              </div>
              <div className="col">
                <h3>Mumbai:</h3>
                <p className="md:max-w-sm">
                  305, Morya Landmark-I, Opposite VIP Plaza, New Link Road
                  Andheri West Mumbai-400053
                </p>
                <p className="md:max-w-sm">Tel: 022 61669755/56</p>
              </div>
            </div>
          </div>

          <div className="mt-10">
            <p className="text-sm mt-10">SOCIALS</p>
            <div className="mt-5 flex justify-center md:justify-start">
              <a target="_blank" href="https://www.instagram.com/ios_sports/">
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.9998 51.3334C40.8865 51.3334 51.3332 40.8867 51.3332 28.0001C51.3332 15.1134 40.8865 4.66675 27.9998 4.66675C15.1132 4.66675 4.6665 15.1134 4.6665 28.0001C4.6665 40.8867 15.1132 51.3334 27.9998 51.3334Z"
                    fill="white"
                  />
                  <path
                    d="M40.756 22.709C40.6936 21.3429 40.4766 20.4101 40.1593 19.5939C39.8372 18.7375 39.332 17.9619 38.6791 17.3208C38.0382 16.6679 37.2624 16.1625 36.406 15.8402C35.5897 15.5231 34.657 15.3064 33.2909 15.2443C31.9223 15.1816 31.4851 15.1667 27.9998 15.1667C24.5146 15.1667 24.0773 15.1816 22.7088 15.2439C21.3427 15.3064 20.41 15.5233 19.5936 15.8406C18.7373 16.1627 17.9617 16.6679 17.3205 17.3208C16.6677 17.9617 16.1623 18.7374 15.8399 19.5937C15.5229 20.4101 15.3061 21.3429 15.244 22.7088C15.1814 24.0776 15.1665 24.5147 15.1665 27.9999C15.1665 31.4853 15.1814 31.9226 15.244 33.2912C15.3063 34.657 15.5233 35.5899 15.8405 36.4063C16.1626 37.2624 16.6679 38.0383 17.3207 38.6792C17.9617 39.3321 18.7375 39.8373 19.5938 40.1594C20.41 40.4768 21.3429 40.6936 22.7089 40.7561C24.0777 40.8185 24.5148 40.8332 28 40.8332C31.4853 40.8332 31.9225 40.8185 33.2911 40.7561C34.6572 40.6936 35.5899 40.4768 36.4062 40.1594C38.1301 39.4928 39.4928 38.1301 40.1593 36.4063C40.4768 35.5899 40.6936 34.657 40.756 33.2912C40.8183 31.9224 40.8332 31.4853 40.8332 28.0001C40.8332 24.5147 40.8183 24.0776 40.756 22.709ZM38.4459 33.186C38.3889 34.4373 38.1798 35.1168 38.0041 35.569C37.5724 36.6883 36.6878 37.5728 35.5685 38.0046C35.1164 38.1802 34.4369 38.3894 33.1856 38.4464C31.8326 38.5082 31.4267 38.5212 27.9998 38.5212C24.5728 38.5212 24.167 38.5082 22.8139 38.4464C21.5628 38.3894 20.8833 38.1802 20.431 38.0046C19.8737 37.7988 19.3694 37.4708 18.9554 37.0445C18.5291 36.6305 18.2011 36.1265 17.9953 35.569C17.8197 35.1168 17.6105 34.4373 17.5536 33.186C17.4919 31.8329 17.4788 31.427 17.4788 28.0003C17.4788 24.5734 17.4919 24.1677 17.5536 22.8143C17.6107 21.563 17.8197 20.8835 17.9953 20.4314C18.2011 19.8739 18.5293 19.3697 18.9554 18.9557C19.3694 18.5294 19.8737 18.2014 20.4312 17.9958C20.8833 17.8199 21.5628 17.611 22.8141 17.5538C24.1672 17.4921 24.5732 17.479 27.9998 17.479H27.9996C31.4263 17.479 31.8323 17.4921 33.1856 17.554C34.4369 17.611 35.1162 17.8201 35.5685 17.9958C36.1258 18.2016 36.6301 18.5296 37.044 18.9557C37.4703 19.3697 37.7983 19.8739 38.0039 20.4314C38.1798 20.8835 38.3889 21.563 38.4459 22.8143C38.5076 24.1675 38.5207 24.5734 38.5207 28.0001C38.5207 31.427 38.5078 31.8327 38.4459 33.186Z"
                    fill="#DA1B22"
                  />
                  <path
                    d="M27.9996 21.4099C24.3601 21.4099 21.4097 24.3605 21.4097 28.0001C21.4097 31.6396 24.3601 34.59 27.9996 34.59C31.6394 34.59 34.5898 31.6396 34.5898 28.0001C34.5898 24.3605 31.6394 21.4099 27.9996 21.4099ZM27.9996 32.2778C25.6373 32.2776 23.7219 30.3625 23.7221 27.9999C23.7221 25.6375 25.6373 23.7222 27.9998 23.7222C30.3624 23.7224 32.2775 25.6375 32.2775 27.9999C32.2775 30.3625 30.3622 32.2778 27.9996 32.2778Z"
                    fill="#DA1B22"
                  />
                  <path
                    d="M36.3901 21.1498C36.3901 22.0002 35.7006 22.6897 34.8502 22.6897C33.9995 22.6897 33.3101 22.0002 33.3101 21.1498C33.3101 20.2991 33.9995 19.6096 34.8502 19.6096C35.7006 19.6096 36.3901 20.2991 36.3901 21.1498Z"
                    fill="#DA1B22"
                  />
                </svg>
              </a>

              <a
                target="_blank"
                href="https://www.linkedin.com/company/ios-sports-&-entertainment/"
              >
                <svg
                  width="46"
                  height="50"
                  viewBox="0 0 56 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_216_3869)">
                    <path
                      d="M27.9998 51.3332C40.8865 51.3332 51.3332 40.8865 51.3332 27.9998C51.3332 15.1132 40.8865 4.6665 27.9998 4.6665C15.1132 4.6665 4.6665 15.1132 4.6665 27.9998C4.6665 40.8865 15.1132 51.3332 27.9998 51.3332Z"
                      fill="white"
                    />
                    <path
                      d="M22.3564 21.3774H17.7369C17.5318 21.3774 17.3657 21.5436 17.3657 21.7486V36.5891C17.3657 36.7941 17.5318 36.9602 17.7369 36.9602H22.3564C22.5614 36.9602 22.7275 36.7941 22.7275 36.5891V21.7486C22.7275 21.5436 22.5614 21.3774 22.3564 21.3774Z"
                      fill="#DA1B22"
                    />
                    <path
                      d="M20.0483 14C18.3675 14 17 15.366 17 17.045C17 18.7247 18.3675 20.0912 20.0483 20.0912C21.7278 20.0912 23.0941 18.7246 23.0941 17.045C23.0942 15.366 21.7278 14 20.0483 14Z"
                      fill="#DA1B22"
                    />
                    <path
                      d="M34.1064 21.0088C32.2511 21.0088 30.8795 21.8064 30.0476 22.7126V21.7488C30.0476 21.5438 29.8815 21.3776 29.6765 21.3776H25.2525C25.0475 21.3776 24.8813 21.5438 24.8813 21.7488V36.5893C24.8813 36.7943 25.0475 36.9604 25.2525 36.9604H29.8619C30.0669 36.9604 30.2331 36.7943 30.2331 36.5893V29.2467C30.2331 26.7724 30.9051 25.8085 32.6299 25.8085C34.5084 25.8085 34.6576 27.3538 34.6576 29.374V36.5894C34.6576 36.7944 34.8238 36.9605 35.0288 36.9605H39.6399C39.8449 36.9605 40.0111 36.7944 40.0111 36.5894V28.4491C40.0111 24.7699 39.3095 21.0088 34.1064 21.0088Z"
                      fill="#DA1B22"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_216_3869"
                      x="-4"
                      y="0"
                      width="64"
                      height="64"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_216_3869"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_216_3869"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </a>

              <a target="_blank" href="https://twitter.com/iosindiaoff">
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 56 57"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.9998 52.25C40.8865 52.25 51.3332 41.6168 51.3332 28.5C51.3332 15.3832 40.8865 4.75 27.9998 4.75C15.1132 4.75 4.6665 15.3832 4.6665 28.5C4.6665 41.6168 15.1132 52.25 27.9998 52.25Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M41.9997 21.4591C41.1078 21.932 40.0177 22.2157 39.0267 22.3103C40.1168 21.6482 40.9096 20.6079 41.306 19.3783C40.315 19.9458 39.2249 20.4187 37.9366 20.7024C36.9456 19.6621 35.6573 19 34.1708 19C31.297 19 28.9186 21.3645 28.9186 24.391C28.9186 24.7694 28.9186 25.2423 29.0177 25.6206C24.6573 25.4314 20.7925 23.2561 18.2159 20.0404C17.7204 20.797 17.5222 21.7428 17.5222 22.7832C17.5222 24.6748 18.4141 26.2826 19.8015 27.2284C18.9096 27.2284 18.1168 26.9447 17.4231 26.5664V26.661C17.4231 29.2146 19.2069 31.3899 21.5853 31.9574C21.1889 32.052 20.6934 32.1466 20.1979 32.1466C19.9006 32.1466 19.5042 32.1466 19.2069 32.052C19.9006 34.2273 21.7835 35.7406 24.0627 35.7406C22.279 37.1593 19.9997 38.0105 17.6213 38.0105C17.2249 38.0105 16.8285 38.0105 16.333 37.9159C18.6123 39.4292 21.3871 40.375 24.36 40.375C33.9726 40.375 39.2249 32.2411 39.2249 25.1477C39.2249 24.9585 39.2249 24.6748 39.2249 24.4856C40.4141 23.5398 41.306 22.594 41.9997 21.4591Z"
                    fill="#DA1B22"
                  />
                </svg>
              </a>

              <a
                target="_blank"
                href="https://www.facebook.com/IOSSportsandEntertainment/"
              >
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.9997 51.3333C40.242 51.3333 50.1663 41.409 50.1663 29.1667C50.1663 16.9244 40.242 7 27.9997 7C15.7574 7 5.83301 16.9244 5.83301 29.1667C5.83301 41.409 15.7574 51.3333 27.9997 51.3333Z"
                    fill="#DA1B22"
                  />
                  <path
                    d="M51.3332 28.142C51.3332 15.178 40.8855 4.66675 27.9998 4.66675C15.1142 4.66675 4.6665 15.178 4.6665 28.142C4.6665 39.8582 13.1979 49.5705 24.3543 51.3334V34.9294H18.4283V28.142H24.3543V22.969C24.3543 17.0861 27.8391 13.8344 33.1679 13.8344C35.7207 13.8344 38.3917 14.2932 38.3917 14.2932V20.0704H35.4484C32.551 20.0704 31.6454 21.8795 31.6454 23.7382V28.142H38.1161L37.0825 34.9294H31.6454V51.3334C42.8018 49.5738 51.3332 39.8615 51.3332 28.142Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div className="bottom mt-10 py-5">
            <small></small>
            <small>ALL RIGHTS RESERVED © 2023 </small>
            <small>CODE BY SAADIWEB</small>
          </div>
        </div>
      </footer>
    </Fragment>
  );
}

export default Footer;
